// src/redux/services/ExchangeRateSlice.js
import { createApi, } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";  
import { mapExchangeRateResponse,mapExchangeRateRequest } from "@/redux/mappers/Export/CreateNewJob/exchRateMappers";

export const importexchangeRateApi = createApi({
  reducerPath: "importexchangeRateApi",
  baseQuery,
  tagTypes: ["ExchangeRate"],
  endpoints: (builder) => ({
    getExchangeRateById: builder.query({
      query: ({ id }) => `import/exchangeRate/${id}`,
      transformResponse: (response) => {
        return mapExchangeRateResponse(response?.data) ?? null;
      },
      providesTags: (result, error, id) => [{ type: "ExchangeRate", id }],
    }),
    

    // ✅ Update Exchange Rate (PUT)
    updateExchangeRate: builder.mutation({
      query: ({ id, ...data }) => {
        const mapped = mapExchangeRateRequest(data);
    
        return {
          url: `import/exchangeRate/${id}`,
          method: "PUT",
          headers: {
            "X-Request-Id": crypto.randomUUID(),
          },
          body: { exchangeRates: mapped.exchangeRates },
        };
      },
      invalidatesTags: ["ExchangeRate"],
    }),
    
  }),
});


// ✅ Hooks
export const {
  useGetExchangeRateByIdQuery,
  useLazyGetExchangeRateByIdQuery,
  useUpdateExchangeRateMutation,
} = importexchangeRateApi;


